require("./wdh-legacy/iframe/js/corporate-template/component-iframe.js");